import React from "react";
import { getPaginationRange, ELLIPSIS } from "../../utils/pagination";

const SimplePagePagination = ({ page, totalPages, onPageChange, className = "d-flex justify-content-end mt-4 px-0" }) => {
  if (!totalPages || totalPages <= 1) return null;

  const pageItems = getPaginationRange(page, totalPages);

  return (
    <div className={className}>
      <nav aria-label="Page navigation">
        <ul className="pagination">
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button type="button" className="page-link" onClick={() => onPageChange(page - 1)} disabled={page === 1}>
              &#10094;
            </button>
          </li>
          {pageItems.map((item, index) =>
            item === ELLIPSIS ? (
              <li key={`ellipsis-${index}`} className="page-item disabled">
                <span className="page-link">…</span>
              </li>
            ) : (
              <li key={item} className={`page-item ${page === item ? "active" : ""}`}>
                <button type="button" className="page-link" onClick={() => onPageChange(item)}>
                  {item}
                </button>
              </li>
            )
          )}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button type="button" className="page-link" onClick={() => onPageChange(page + 1)} disabled={page === totalPages}>
              &#10095;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default SimplePagePagination;
